import { useEffect, useState } from 'react';

import { canApproveParticipants } from 'pages/Dashboard/home-reads';
import { isAppreciationLadderManager } from 'pages/Dashboard/taskCyclesVisibility';
import { getTasksPendingApprovalParticipants } from 'services/dashboard.service';
import { UserInfoInterface } from 'types/user';

import { resolveFlowEligibility } from './ApreciarRealizacao/shared/eligibility';
import { PendenciasDoLider } from './components/PanoramaDaEquipe';

/**
 * Contagens das ações do líder (EQP-04, EQP-08). Cada leitura só acontece para quem tem a ação;
 * `null` = não se aplica ou a leitura da validação falhou (o cartão fica sem rodapé de contagem).
 * A leitura de participantes devolve [] quando falha, então a falha aparece como 0.
 * Ao contrário da Home, não abre o aviso de participações pendentes.
 */
export function usePendenciasDoLider(playerId: string | undefined, userInfo: UserInfoInterface | undefined) {
  const [pendencias, setPendencias] = useState<PendenciasDoLider>({ validacao: null, autorizacao: null });

  const lerValidacao = !!playerId && isAppreciationLadderManager(userInfo);
  const lerAutorizacao = !!playerId && canApproveParticipants(userInfo);

  useEffect(() => {
    if (!lerValidacao) return;
    let ativo = true;

    resolveFlowEligibility(playerId)
      .then(elegibilidade => (elegibilidade ? (elegibilidade.normalPending ?? 0) + (elegibilidade.madPending ?? 0) : null))
      .catch(() => null)
      .then(validacao => ativo && setPendencias(atuais => ({ ...atuais, validacao })));

    return () => {
      ativo = false;
    };
  }, [playerId, lerValidacao]);

  useEffect(() => {
    if (!lerAutorizacao) return;
    let ativo = true;

    getTasksPendingApprovalParticipants()
      .then(tarefas => (Array.isArray(tarefas) ? tarefas.length : null))
      .catch(() => null)
      .then(autorizacao => ativo && setPendencias(atuais => ({ ...atuais, autorizacao })));

    return () => {
      ativo = false;
    };
  }, [playerId, lerAutorizacao]);

  // Ação que deixou de valer (ex.: `userInfo` atualizado) não mostra a contagem lida antes.
  return {
    validacao: lerValidacao ? pendencias.validacao : null,
    autorizacao: lerAutorizacao ? pendencias.autorizacao : null,
  };
}
